import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { UitkInput } from './uitk-input.esm.js';

var UitkTextInput = /** @class */ (function (_super) {
    __extends(UitkTextInput, _super);
    function UitkTextInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkTextInput.prototype.render = function () {
        return React.createElement(UitkInput, __assign({}, this.props, { type: "text" }));
    };
    UitkTextInput.displayName = 'UitkTextInput';
    return UitkTextInput;
}(React.Component));

export { UitkTextInput };
